import React from "react"
import { normalizePhoneInput } from "../../../utils/phone"
import CustomTextInput, {
  CustomTextInputProps,
} from "../../atoms/CustomTextInput"

const PhoneInput = (props: CustomTextInputProps) => {
  const handlePhoneChange = (e: React.FormEvent) => {
    const event = e as any
    event.target.value = normalizePhoneInput(event.target.value)
  }

  return (
    <CustomTextInput {...props} inputMode="tel" onInput={handlePhoneChange} />
  )
}

export default PhoneInput

PhoneInput.defaultProps = {
  ...CustomTextInput.defaultProps,
}
